'use client';

import { Hero } from 'components/hsa-fsa/Hero';
import { ProductSection } from 'components/hsa-fsa/Products';
import { Steps } from 'components/hsa-fsa/Steps';
import { useRef } from 'react';
import { hsaFsaFaqData } from 'components/hsa-fsa/faqData';
import { analytics } from 'lib/analytics/analytics';
import { FAQSection } from 'components/shared/FAQSection';

const HSAFSA = () => {
  const productSectionRef = useRef<HTMLDivElement>(null);

  const navigateToProductSection = () => {
    analytics.track(`generic - HSA/FSA  explore products`);
    if (productSectionRef.current) {
      productSectionRef.current.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      });
    }
  };
  return (
    <>
      <Hero handleCtaClick={navigateToProductSection} />
      <Steps />
      <ProductSection ref={productSectionRef} />
      <FAQSection faqData={hsaFsaFaqData} />
    </>
  );
};

export default HSAFSA;
